import React from 'react';
import { CalendarToday as CalendarIcon } from '@mui/icons-material';
import IconButtonControl from './IconButtonControl';

/**
 * Specialized Calendar Button for date selection
 */
export default function CalendarButtonControl({
  onClick,
  disabled = false,
  variant = 'yellow',
  tooltip = 'Select Date Range',
  ...props
}) {
  return (
    <IconButtonControl
      icon={CalendarIcon}
      onClick={onClick}
      disabled={disabled}
      variant={variant}
      tooltip={tooltip}
      {...props}
    />
  );
}